import { SystemField } from "./system-field";

export class ReceiptProduct extends SystemField{
     
     ref_code?:string;
     external_ref_code?:string;
     receipt_date?:string;
     status?:string;
     post_period?:string;
     reason_code_id?:string;
     total_qty?:number;
     total_cost?:number;
     transfer_prod_id?:string;
     warehouse_id?:string;

}
